import { PortalError } from './PortalError';

export class ElementNotFoundError extends PortalError {
  constructor() {
    super('ElementNotFoundError', 'No permissions to access this page', 'id_no_permissions');
  }
}
